import React from 'react';

function isColorDark(hex) {
  if (!hex || hex.length < 7) return false;
  const r = parseInt(hex.slice(1,3),16);
  const g = parseInt(hex.slice(3,5),16);
  const b = parseInt(hex.slice(5,7),16);
  return (r*299 + g*587 + b*114) / 1000 < 128;
}

function buildTranches(s) {
  return [
    {
      id:'senior',
      label:   s['tranche.senior.label']    || '',
      rate:    s['tranche.senior.rate']     || '',
      headBg:  s['tranche.senior.color']    || '#1D6B6E',
      rows:[
        ['Montant',       s['tranche.senior.montant']   || ''],
        ['Maturité',      s['tranche.senior.maturite']  || ''],
        ['Prix unitaire', s['tranche.senior.prix']      || ''],
        [s['tranche.senior.extra_key'] || '', s['tranche.senior.extra_val'] || ''],
      ].filter(([k]) => k !== ''),
      badge:      s['tranche.senior.badge'] || '',
      badgeStyle: { background:'#FFF3CD', color:'#856404' },
    },
    {
      id:'mezzanine',
      label:   s['tranche.mezz.label']    || '',
      rate:    s['tranche.mezz.rate']     || '',
      headBg:  s['tranche.mezz.color']    || '#C8982A',
      rows:[
        ['Montant',       s['tranche.mezz.montant']   || ''],
        ['Maturité',      s['tranche.mezz.maturite']  || ''],
        ['Prix unitaire', s['tranche.mezz.prix']      || ''],
        [s['tranche.mezz.extra_key'] || '', s['tranche.mezz.extra_val'] || ''],
      ].filter(([k]) => k !== ''),
      badge:      s['tranche.mezz.badge'] || '',
      badgeStyle: { background:'#FFF3CD', color:'#856404' },
    },
    {
      id:'junior',
      label:   s['tranche.junior.label']    || '',
      rate:    s['tranche.junior.rate']     || '',
      altRate: s['tranche.junior.alt_rate'] || '',
      headBg:  s['tranche.junior.color']    || '#8B4513',
      rows:[
        ['Montant',  s['tranche.junior.montant']  || ''],
        ['Maturité', s['tranche.junior.maturite'] || ''],
        ['Cédants',   s['tranche.junior.cedant']   || ''],
        ['Statut',   s['tranche.junior.statut']   || ''],
      ].filter(([, v]) => v !== ''),
      badge:      s['tranche.junior.badge'] || '',
      badgeStyle: { background:'#FBE9E7', color:'#BF360C' },
    },
  ];
}

function sectionBg(theme, settings) {
  if (!theme) return '#ffffff';
  if (theme.startsWith('#')) return theme; // couleur personnalisée
  if (theme === 'dark')  return settings['color.primary'] || '#0A1628';
  if (theme === 'blue')  return '#0D3B6E';
  return '#ffffff';
}

export default function Tranches({ content, settings = {}, sectionCfg = {} }) {
  const tranches = buildTranches(settings);
  const theme    = sectionCfg.bg?.startsWith('#') ? 'custom'
                 : sectionCfg.theme || settings['theme.tranches'] || 'light';
  const bg       = sectionCfg.bg?.startsWith('#') ? sectionCfg.bg : sectionBg(theme, settings);
  const isDark   = theme !== 'light' && theme !== 'custom' ? true
                 : sectionCfg.bg?.startsWith('#') ? isColorDark(sectionCfg.bg) : false;

  return (
    <section id="tranches" style={{ padding:'4rem 0', background:bg }}>
      <style>{`
        .tranches-grid { display:grid; grid-template-columns:1fr; gap:1.2rem; margin-top:2rem; }
        @media(min-width:640px){ .tranches-grid{ grid-template-columns:repeat(2,1fr); } }
        @media(min-width:900px){ .tranches-grid{ grid-template-columns:repeat(3,1fr); } }
      `}</style>
      <div className="section-inner">
        {/* <div className="section-label">{content.label || 'Structure d\'émission'}</div> */}
        <h2 className="section-title" style={{ color:isDark?'#fff':undefined }}>{content.title || ''}</h2>
        <p className="section-desc" style={{ color:isDark?'rgba(255,255,255,0.6)':undefined }}>{content.subtitle || ''}</p>
        <div className="tranches-grid">
          {tranches.map(t => (
            <div key={t.id} style={{ borderRadius:6, overflow:'hidden', border:`1px solid ${isDark?'rgba(255,255,255,0.1)':'var(--color-border)'}` }}>
              <div style={{ padding:'1.2rem 1.5rem', background:t.headBg, color:'white' }}>
                <div style={{ fontSize:10, letterSpacing:2, textTransform:'uppercase', opacity:.7, marginBottom:4 }}>{t.label}</div>
                {t.rate
                  ? <div style={{ fontFamily:"var(--font-heading, 'Playfair Display',serif)", fontSize:'2.4rem', fontWeight:900, lineHeight:1 }}>{t.rate}</div>
                  : <div style={{ fontFamily:"var(--font-heading, 'Playfair Display',serif)", fontSize:'1.3rem', fontWeight:700, lineHeight:1.3, whiteSpace:'pre-line' }}>{t.altRate}</div>
                }
                <div style={{ fontSize:12, opacity:.7, marginTop:4, fontFamily:"var(--font-body, 'DM Sans',sans-serif)" }}>Taux d'intérêt annuel</div>
              </div>
              <div style={{ padding:'1.2rem 1.5rem', background:isDark?'rgba(255,255,255,0.04)':'#fff' }}>
                {t.rows.map(([k,v]) => (
                  <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'0.5rem 0', borderBottom:`1px solid ${isDark?'rgba(255,255,255,0.07)':'var(--color-border)'}`, fontSize:13 }}>
                    <span style={{ color:isDark?'rgba(255,255,255,0.5)':'var(--color-text-mid)' }}>{k}</span>
                    <span style={{ fontWeight:600, color:isDark?'#fff':undefined }}>{v}</span>
                  </div>
                ))}
                <span style={{ display:'inline-block', padding:'3px 10px', borderRadius:2, fontSize:10, letterSpacing:1, textTransform:'uppercase', fontWeight:600, marginTop:'0.8rem', ...t.badgeStyle }}>{t.badge}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
